/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectCalculationsScenarioCompareRetrieve$Params {
  /**
   * id эталонного сценария
   */
  baseline: number;

  /**
   * csv id остальных сценариев
   */
  others: string;

  /**
   * Номер страницы (default 1)
   */
  page?: number;

  /**
   * Размер страницы по others, 1..10 (default 10)
   */
  page_size?: number;
}

export function projectCalculationsScenarioCompareRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsScenarioCompareRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsScenarioCompareRetrieve.PATH, 'get');
  if (params) {
    rb.query('baseline', params.baseline, {});
    rb.query('others', params.others, {});
    rb.query('page', params.page, {});
    rb.query('page_size', params.page_size, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

projectCalculationsScenarioCompareRetrieve.PATH = '/api/project_calculations/scenario_compare/';
